export default `
 ### Heading
 Paragraph with [a link](http://www.google.com)
 Another paragraph
`.trim();



// WEBPACK FOOTER //
// ./src/fixtures/privacy.js